import { render } from "./ClinicCalendar.vue?vue&type=template&id=356e153f"
import script from "./ClinicCalendar.vue?vue&type=script&lang=js"
export * from "./ClinicCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/echo-public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__